exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".side-container .input-holder {\n  width: 100%;\n  height: 48px;\n}\n.side-container .suppliers-list {\n  width: 100%;\n  height: calc(500px - 48px);\n  overflow-x: scroll;\n}\n.side-container .suppliers-list .card-body {\n    padding: 0;\n}\n.side-container .options-holder {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n.side-container .options-holder bbutton {\n    padding-right: 0;\n}\n", ""]);

// exports
